// Sprint 32.1 hotfix — shared friendly provider names, so every tenant-facing
// screen that shows a provider_key (AIDashboard, AITestConsole, ObservabilityCenter,
// IntegrationCenter, EmailTemplates) uses the same translation instead of each
// screen inventing (or forgetting) its own.
export const AI_PROVIDER_NAMES = {
  openai: 'ChatGPT (OpenAI)', anthropic: 'Claude (Anthropic)', gemini: 'Google Gemini',
  mistral: 'Mistral AI', deepseek: 'DeepSeek', groq: 'Groq', cohere: 'Cohere',
  xai: 'xAI (Grok)', openrouter: 'OpenRouter', azure_openai: 'Azure OpenAI',
};
export const friendlyAiProviderName = (key) => AI_PROVIDER_NAMES[key] || key;

export const EMAIL_PROVIDER_NAMES = {
  smtp: 'SMTP', smtp_custom: 'SMTP', sendgrid: 'SendGrid', resend: 'Resend',
  mailgun: 'Mailgun', ses: 'Amazon SES', brevo: 'Brevo',
};
export const friendlyEmailProviderName = (key) => EMAIL_PROVIDER_NAMES[key] || key;

export const WHATSAPP_PROVIDER_NAMES = {
  evolution_api: 'WhatsApp (Evolution)', meta_whatsapp: 'WhatsApp (Meta oficial)',
  meta_cloud: 'WhatsApp (Meta oficial)', whatsapp_business: 'WhatsApp Business',
  gupshup: 'WhatsApp (Gupshup)', twilio_whatsapp: 'WhatsApp (Twilio)',
};

export const ALL_PROVIDER_NAMES = { ...AI_PROVIDER_NAMES, ...EMAIL_PROVIDER_NAMES, ...WHATSAPP_PROVIDER_NAMES };
export const friendlyProviderName = (key) => ALL_PROVIDER_NAMES[key] || key;
